<template>
    <div class="modal fade" id="searchCampaignMapModal" ref="searchCampaignMapModal" tabindex="-1" role="dialog" aria-labelledby="searchCampaignMapModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="modal-title" id="campaignDetailsModalLabel">{{ $t('search_campaign.title') }}</h5>
                        </div>
                        <div class="col-12">
                            <span class="add-location-title float-left mt-3 mb-3">{{ $t('search_campaign.campaign_reception') }}</span>
                        </div>
                        <div class="col-12">
                            <span class="starRatingFilter">
                                <input @click="setReceptionResetValue(5)" @tap="setReceptionResetValue(5)" id="rating5" type="radio" name="rating" value="5" v-model="$parent.searchParameters.reception">
                                <label for="rating5"></label>
                                <input @click="setReceptionResetValue(4)" @tap="setReceptionResetValue(4)" id="rating4" type="radio" name="rating" value="4" v-model="$parent.searchParameters.reception">
                                <label for="rating4"></label>
                                <input @click="setReceptionResetValue(3)" @tap="setReceptionResetValue(3)" id="rating3" type="radio" name="rating" value="3" v-model="$parent.searchParameters.reception">
                                <label for="rating3"></label>
                                <input @click="setReceptionResetValue(2)" @tap="setReceptionResetValue(2)" id="rating2" type="radio" name="rating" value="2" v-model="$parent.searchParameters.reception">
                                <label for="rating2"></label>
                                <input @click="setReceptionResetValue(1)" @tap="setReceptionResetValue(1)" id="rating1" type="radio" name="rating" value="1" v-model="$parent.searchParameters.reception">
                                <label for="rating1"></label>
                            </span>
                        </div>
                        <div class="col-12">
                            <span class="starRatingLabels">
                                <span class="float-left ml-3 reception-labels">{{ $t('search_campaign.annoyed') }}</span><span class="float-right mr-2 reception-labels">{{ $t('search_campaign.happy') }}</span>
                            </span>
                        </div>
                        <div class="col-12">
                            <span class="add-location-title float-left mt-3 mb-3">{{ $t('search_campaign.talking_points') }}</span>
                        </div>
                        <div class="col-12">
                            <div v-for="(question, index) in currentCampaignComputed.questions" v-if="question.is_visible == true" class="row mb-3" :key="index">
                                <div v-if="question.type != 'open'" class="col-12">
                                    <span class="question-text">{{question.text}}</span>
                                </div>
                                <div v-if="question.type != 'open'" v-for="(answer, indexAnswer) in question.answers" class="col-12" :key="indexAnswer">
                                    <input :type="question.type == 'single' ? 'radio' : 'checkbox'" :id="answer._id" :name="question.type == 'single' ? question._id  : answer._id" :value="answer._id" v-model="$parent.searchParameters.answers[question._id]">
                                    <label class="mr-2" :for="answer._id"><span></span><div class="answer-text">{{ answer.text }}</div></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="w-100 row mb-5">
                        <div class="col-6">
                            <button @click.prevent="saveFilter" class="btn shadow btn-app btn-block primaryBackground">{{ $t('search_campaign.save_filter') }}</button>
                        </div>
                        <div class="col-6">
                            <button @click.prevent="clearFilter" class="btn shadow btn-app btn-block cancelOrangeButton">{{ $t('search_campaign.clear_filter') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "SearchCampaignMapModal",
        props: ["searchParameters"],
        mixins: [HelperMixin],
        data() {
            return {
                previousReceptionValue: 0,
            }
        },
        created() {
            
        },
        computed: {
            currentCampaignComputed() {
                return this.$store.getters["currentCampaign"];
            }
        },
        methods: {
            setReceptionResetValueTouch(val) {
                if (val == 1 && val == this.previousReceptionValue) {
                    this.$parent.searchParameters.reception = 0;
                } else {
                    this.previousReceptionValue = val;
                }
            },
            setReceptionResetValue(val) {
                if (val == 1 && val == this.previousReceptionValue) {
                    this.$parent.searchParameters.reception = 0;
                } else {
                    this.previousReceptionValue = val;
                }
            },

            saveFilter() {
                if (this.$parent.searchParameters.reception != 0) {
                     this.$parent.isFilter = true;
                }
                for (let [key, value] of Object.entries(this.$parent.searchParameters.answers)) {
                    if (value.length > 0) {
                        this.$parent.isFilter = true;
                    }
                }
                this.$parent.markers = [];
                this.$parent.page = null;
                this.$parent.rememberBounds = null;
                this.$parent.giveRememberBounds = false;
                this.dismissDetails();
                this.$parent.getMarkersLocations();
            },

            clearFilter() {
                this.$router.go();
            },

            dismissDetails() {
                $('#searchCampaignMapModal').modal('hide');
            },
        },
    };
</script>
